import {
    type AdSlotProps
} from 'react-dfp';

type Slot =
  | 'Publication_300x100_Mobile'
  | 'Publication_LPiInternal_300x150'
  | 'Publication_WCSponsor_300x100_Mobile'
  | 'Publication_WCSponsor_728x90'
  | 'Publication_XL_300x600';

type Themed = Record<'POL' | 'MCO', Record<Slot, AdSlotProps>>;

const THEMED_ADVERTISEMENT_SLOTS: Themed = {
    MCO: {
        Publication_300x100_Mobile: {
            adUnit: 'MCO_Publication_300x100_Mobile',
            sizes: [
                [
                    300,
                    100
                ]
            ],
            slotId: 'mco-publication-300x100-mobile'
        },
        Publication_LPiInternal_300x150: {
            adUnit: 'MCO_Publication_LPiInternal_300x150',
            sizes: [
                [
                    300,
                    150
                ]
            ],
            slotId: 'mco-publication-lpiinternal-300x150'
        },
        Publication_WCSponsor_300x100_Mobile: {
            adUnit: 'MCO_Publication_WCSponsor_300x100_Mobile',
            sizes: [
                [
                    300,
                    100
                ]
            ],
            slotId: 'mco-publication-wcsponsor-300x100-mobile'
        },
        Publication_WCSponsor_728x90: {
            adUnit: 'MCO_Publication_WCSponsor_728x90',
            sizes: [
                [
                    728,
                    90
                ]
            ],
            slotId: 'mco-publication-wcsponsor-728x90'
        },
        Publication_XL_300x600: {
            adUnit: 'MCO_Publication_XL_300x600',
            sizes: [
                [
                    300,
                    600
                ]
            ],
            slotId: 'mco-publication-xl-300x600'
        }
    },
    POL: {
        Publication_300x100_Mobile: {
            adUnit: 'POL_Publication_300x100_Mobile',
            sizes: [
                [
                    300,
                    100
                ]
            ],
            slotId: 'pol-publication-300x100-mobile'
        },
        Publication_LPiInternal_300x150: {
            adUnit: 'POL_Publication_LPiInternal_300x150',
            sizes: [
                [
                    300,
                    150
                ]
            ],
            slotId: 'pol-publication-lpiinternal-300x150'
        },
        Publication_WCSponsor_300x100_Mobile: {
            adUnit: 'POL_Publication_WCSponsor_300x100_Mobile',
            sizes: [
                [
                    300,
                    100
                ]
            ],
            slotId: 'pol-publication-wcsponsor-300x100-mobile'
        },
        Publication_WCSponsor_728x90: {
            adUnit: 'POL_Publication_WCSponsor_728x90',
            sizes: [
                [
                    728,
                    90
                ]
            ],
            slotId: 'pol-publication-wcsponsor-728x90'
        },
        Publication_XL_300x600: {
            adUnit: 'POL_Publication_XL_300x600',
            sizes: [
                [
                    300,
                    600
                ]
            ],
            slotId: 'pol-publication-xl-300x600'
        }
    }
};

export default THEMED_ADVERTISEMENT_SLOTS;
